import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_PRODUCT_PRICE_PENDING,
  GET_PRODUCT_PRICE,
  SG_GET_PRODUCT_PRICE,
  GET_PRODUCT_PRICE_SELECT,
  SG_GET_PRODUCT_PRICE_SELECT,
  DELETE_PRODUCT_PRICE,
  SG_DELETE_PRODUCT_PRICE,
  FETCH_PRODUCT_PRICE,
  SG_FETCH_PRODUCT_PRICE,
  EDIT_PRODUCT_PRICE,
  SG_EDIT_PRODUCT_PRICE,
  ADD_PRODUCT_PRICE,
  SG_ADD_PRODUCT_PRICE,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";


function* loadprocess(action) {
  yield put({ type: GET_PRODUCT_PRICE_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_PRODUCT_PRICE, action.payload);
    yield put({ type: GET_PRODUCT_PRICE, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processLoad() {
  yield takeLatest(SG_GET_PRODUCT_PRICE, loadprocess);
}

function* selectprocess(action) {
  yield put({ type: GET_PRODUCT_PRICE_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_PRODUCT_PRICE_SELECT, action.payload);
    yield put({ type: GET_PRODUCT_PRICE_SELECT, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processSelect() {
  yield takeLatest(SG_GET_PRODUCT_PRICE_SELECT, selectprocess);
}

function* fetchprocess(action) {
  try {
    const json = yield call(api.FETCH_PRODUCT_PRICE, action.payload);
    yield put({ type: FETCH_PRODUCT_PRICE, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processFetch() {
  yield takeLatest(SG_FETCH_PRODUCT_PRICE, fetchprocess);
}

function* updateprocess(action) {
  try {
    const json = yield call(api.EDIT_PRODUCT_PRICE, action.payload);
    yield put({ type: EDIT_PRODUCT_PRICE, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processUpdate() {
  yield takeLatest(SG_EDIT_PRODUCT_PRICE, updateprocess);
}

function* addprocess(action) {
  try {
    const json = yield call(api.ADD_PRODUCT_PRICE, action.payload);
    yield put({ type: ADD_PRODUCT_PRICE, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processAdd() {
  yield takeLatest(SG_ADD_PRODUCT_PRICE, addprocess);
}

function* deleteprocess(action) {
  try {
    const json = yield call(api.DELETE_PRODUCT_PRICE, action.payload);
    yield put({ type: DELETE_PRODUCT_PRICE, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processDelete() {
  yield takeLatest(SG_DELETE_PRODUCT_PRICE, deleteprocess);
}

export default function* index() {
  yield all([
    processLoad(),
    processSelect(),
    processFetch(),
    processUpdate(),
    processAdd(),
    processDelete(),
  ]);
}
